// src/redux/slices/filterSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    daysFilter: "UPCOMING",
    order: -1
};

const filterSlice = createSlice({
    name: "filters",
    initialState,
    reducers: {
        setFilter: (state, action) => {
            const { name, value } = action.payload;
            state[name] = value;
        },
        resetEventFilters: () => initialState,
    },
});

export const { setFilter, resetEventFilters } = filterSlice.actions;
export default filterSlice.reducer;
